'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoArrowRightB = function IoArrowRightB(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm14.5 32.3c-0.2 0.1-0.5 0.2-0.7 0.2-0.8 0-1.3-0.6-1.3-1.3v-22.4c0-0.7 0.5-1.3 1.3-1.3 0.2 0 0.4 0.1 0.6 0.2l0.2 0.2 12.2 10.6c0.4 0.4 0.7 0.9 0.7 1.5s-0.3 1.1-0.7 1.5l-12.2 10.6z' })
        )
    );
};

exports.default = IoArrowRightB;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/arrow-right-b.js
// module id = 1947
// module chunks = 0